<div mat-dialog-title>
    พิมพ์ {{ titleType }} และบันทึก
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography">
    <div class="container p-3">
        <form [formGroup]="printForm">
            <div class="row justify-content-center">
                <div class="col-8">
                    <mat-radio-group formControlName="type">
                        <mat-radio-button value="original" style="margin-left: 50px;">ต้นฉบับ</mat-radio-button><br>
                        <mat-radio-button *ngIf="type !== 'quotation'" value="copy" style="margin-left: 50px;">สำเนา</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </form>

        <div class="row justify-content-center pt-5 pb-3">
            <lifedi-btn *ngIf="printForm.valid" lable="พิมพ์" class="mr-3"
                customStyle="background-color: #060E9F; color: #FFF; width: 100%;" (click)="print(printForm.value)">
            </lifedi-btn>
            <lifedi-btn *ngIf="!printForm.valid" lable="พิมพ์" class="mr-3" disabled="true"
                customStyle="background-color: #C4C4C4; color: #FFF; width: 100%;">
            </lifedi-btn>
            <lifedi-btn lable="ยกเลิก" customStyle="background-color: #C4C4C4; color: #FFF; width: 100%;"
                (click)="closeModal()">
            </lifedi-btn>
        </div>
    </div>
</mat-dialog-content>